import React from "react";
import { default as WCheckbox } from "@mui/material/Checkbox";

function Checkbox(props) {
  return <WCheckbox {...props} />;
}

export default Checkbox;
